// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3AzoU","title":"Info_title__1S9NI","links":"Info_links__1GiVn","link":"Info_link__1tkod","logo":"Info_logo__2wAzn"};